import {
  GET_LIST_DANHSACHDONHANG,
  GET_LIST_DANHSACHDONHANG_SUCCESS,
  GET_LIST_DANHSACHDONHANG_FAILURE,
  UPDATE_DANHSACHDONHANG,
} from "../../actions/DanhSachDonHang/actionTypes";
import moment from "moment";

const initialState = {
  List: [],
  List2: [],
  SumValue: 0,
  iTotal: 0,
  GhiChu: "",
  TotalValue1: 0,
  TotalValue2: 0,
  TuNgay: moment().format("YYYY-MM-DD HH:mm"),
  DenNgay: moment().format("YYYY-MM-DD HH:mm"),
  IsConfig: false,
  isProgress: false,
};

const getListDanhSachDonDatHang = (state, action) => ({
  ...state,
  isProgress: true,
});

const getListDanhSachDonDatHangSuccess = (state, action) => {
  return {
    ...state,
    List: action.payload.List,
    List2: action.payload.List2,
    SumValue: action.payload.SumValue,
    iTotal: action.payload.iTotal,
    GhiChu: action.payload.GhiChu,
    TotalValue1: action.payload.TotalValue1,
    TotalValue2: action.payload.TotalValue2,
    TuNgay: action.payload.TuNgay,
    DenNgay: action.payload.DenNgay,
    IsConfig: action.payload.IsConfig,
    isProgress: false,
  };
};

const getListDanhSachDonDatHangFailed = (state, action) => ({
  ...state,
  isProgress: false,
  List: [],
});

const updateListDanhSachDonDatHang = (state, action) => {
  return {
    ...state,
    List2: action.payload.List2,
  };
};

export const listDanhSachDonHangReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_DANHSACHDONHANG:
      return getListDanhSachDonDatHang(state, action);
    case GET_LIST_DANHSACHDONHANG_SUCCESS:
      // alert("tuty");
      return getListDanhSachDonDatHangSuccess(state, action);
    case GET_LIST_DANHSACHDONHANG_FAILURE:
      //alert('false')
      return getListDanhSachDonDatHangFailed(state, action);
    case UPDATE_DANHSACHDONHANG:
      return updateListDanhSachDonDatHang(state, action);
    default:
      return state;
  }
};

export default listDanhSachDonHangReducer;
